/**
 * TanStack Query hooks for `hasoffers-tune-integration-via-api`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	hasoffersTuneIntegrationViaApiQueryKeys,
	type CreateHasoffersTuneIntegrationViaApiBody,
	type ListHasoffersTuneIntegrationViaApiResponse,
	type HasoffersTuneIntegrationViaApiRow,
} from "./api";

export function useHasoffersTuneIntegrationViaApiList(): UseQueryResult<ListHasoffersTuneIntegrationViaApiResponse, Error> {
	return useQuery({
		queryKey: hasoffersTuneIntegrationViaApiQueryKeys.list(),
		queryFn: list,
	});
}

export function useHasoffersTuneIntegrationViaApiCreate(): UseMutationResult<HasoffersTuneIntegrationViaApiRow, Error, CreateHasoffersTuneIntegrationViaApiBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: hasoffersTuneIntegrationViaApiQueryKeys.all });
		},
	});
}

export function useHasoffersTuneIntegrationViaApiDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: hasoffersTuneIntegrationViaApiQueryKeys.all });
		},
	});
}
